import {
	CallbackProperty,
	Cartesian2,
	Cartesian3,
	Ellipsoid,
	Cartographic,
	Color,
	DataSourceCollection,
	DataSourceDisplay,
	Entity,
	GridMaterialProperty,
	Math as CesiumMath,
	Rectangle,
	sampleTerrainMostDetailed,
} from 'cesium';
import { HistoryItem } from '@/classes/History';

export function leftClickDefault(click) {
	const cesiumViewer = this.getCesiumData().viewer;
	try {
		const pickResult = cesiumViewer.scene.drillPick(click.position);
		const selectedLocation = cesiumViewer.scene.pickPosition(
			click.position
		);
		const positionCartographic = Ellipsoid.WGS84.cartesianToCartographic(
			selectedLocation
		);
		const latitude = CesiumMath.toDegrees(positionCartographic.latitude);
		const longitude = CesiumMath.toDegrees(positionCartographic.longitude);
		this.modelWorkflow.position = { longitude, latitude };
		const height = this.getTerrainHeight(selectedLocation);
		this.mouseEndPosition = { longitude, latitude, height };
		this.shapeAuthoringWorkflow.placementMarker.position = Cartesian3.fromDegrees(this.mouseEndPosition.longitude, this.mouseEndPosition.latitude);
		
		if (!this.shapeAuthoringWorkflow.placementMarker.show) this.shapeAuthoringWorkflow.placementMarker.show = true;
		cesiumViewer.scene.requestRender();

		if (this.modelWorkflow.moveActive) {
			this.moveModel(this.modelWorkflow.focusedId, selectedLocation);
			this.hidePlacementMarker();
		}
		if (this.dragMode) {
			this.dragMode = false;
			this.shapeAuthoringWorkflow.lineEntity.show = false;
			this.shapeAuthoringWorkflow.modelBoundingBox.show = false;
			cesiumViewer.scene.screenSpaceCameraController.enableZoom = true;
			this.moveModel(this.modelWorkflow.focusedId, selectedLocation);
			this.hidePlacementMarker();							
			this.$refs.modelrotation.$emit('change');		
		}
		
		console.log(pickResult);
		const isBuilding3d = pickResult.find((x) => !!x.getPropertyNames);
		if (isBuilding3d) {
			const alreadyAddedOsmBuilding = this.osmWorkflow.addedIds.find(
				(x) => x.elementId === isBuilding3d.getProperty('elementId')
			);
			if (alreadyAddedOsmBuilding) {
				const osmParent = this.$_linearEntities.find(
					(x) =>
						x.data[0].data &&
						x.data[0].data.elementId ===
						alreadyAddedOsmBuilding.elementId
				).parent;
				this.emitEntityClicked(osmParent);
			}
		}
		const entityWithAssetData = pickResult
			.map((p) => p.primitive.id || p.id.layer)
			.map((x) => this.$_linearEntities[x])
			.find((type) => type.type === 'file' || type.data[0].data.asset);
		if (pickResult && entityWithAssetData) {
			this.emitEntityClicked(entityWithAssetData.id);
		}
		if (this.$_linearEntities[entityWithAssetData.id].data[0].data.gltf) {
			console.log(entityWithAssetData);
			this.setFocusedModel(entityWithAssetData.id);
		}
	} catch (error) {
		/* break; */
	}
}

export function leftClickOsmSelect(click) {
	const cesiumViewer = this.getCesiumData().viewer;
	const pickResult = cesiumViewer.scene.drillPick(click.position);
	const isBuilding3d = pickResult.find((x) => !!x.getPropertyNames);
	let props;
	if (isBuilding3d) {
		props = isBuilding3d
			.getPropertyNames()
			.map((propertyName) => [
				propertyName,
				isBuilding3d.getProperty(propertyName),
			])
			.reduce((result, currentValue) => {
				const [property, value] = currentValue;
				if (value) result[property] = value;
				return JSON.parse(JSON.stringify(result));
			}, {});

		const alreadyAddedOsmBuilding = this.osmWorkflow.addedIds.find(
			(x) => x.elementId === props.elementId
		);
		if (!alreadyAddedOsmBuilding) {
			if (
				this.osmWorkflow.selectedIds.find(
					(y) => y.elementId === props.elementId
				)
			) {
				this.osmWorkflow.selectedIds = this.osmWorkflow.selectedIds.filter(
					(z) => z.elementId !== props.elementId
				);
				this.$root.$emit('unselected-building', props.elementId);
			} else {
				props.show = true;
				this.osmWorkflow.selectedIds.push(props);
				this.$root.$emit('selected-building', props);
			}
			this.updateOsmStyle();
		}
		if (this.osmWorkflow.selectedIds.length > 0) {
			this.$store.commit('setBuildingsSelected', true);
		} else {
			this.$store.commit('setBuildingsSelected', false);
			if (document.body.style.cursor === 'wait') {
				document.body.style.cursor = 'default';
			}
		}
	}
}

export function leftClickSaw(click) {
	const cesiumViewer = this.getCesiumData().viewer;
	if (this.shapeAuthoringWorkflowLoopClosed) return;
	const clickPos = new Cartesian3();
	cesiumViewer.scene.pickPosition(click.position, clickPos);
	const historyItem = new HistoryItem(
		this.$t('shape-authoring-workflow.history.append-vertex'),
		() => {
			this.shapeAuthoringWorkflow.vertices.push(clickPos);
			this.shapeAuthoringWorkflow.screenVertices.push(new Cartesian2());
			this.updateShapeAuthoringVertices();
		},
		() => {
			this.shapeAuthoringWorkflow.vertices.pop();
			this.shapeAuthoringWorkflow.screenVertices.pop();
			this.updateShapeAuthoringVertices();
		}
	);
	historyItem.redo();
	this.shapeAuthoringWorkflow.selectedVertexId =
		this.shapeAuthoringWorkflow.vertices.length - 1;
	this.shapeAuthoringWorkflow.history.push(historyItem);
}

export function leftClickPlaceMent(click) {
	const cesiumViewer = this.getCesiumData().viewer;
	const place = cesiumViewer.scene.pickPosition(click.position);
	console.log(`placement: ${place}`);
	const historyItem = new HistoryItem(
		this.$t('placement-workflow.history.placed'),
		() => {
			this.placementWorkflow.positions.push(place);
			this.$emit('place', place);
		},
		() => {
			this.placementWorkflow.positions.pop();
		}
	);
	historyItem.redo();
	this.placementWorkflow.history.push(historyItem);
}

export function rightClickDefault(rightClick) {

	const cesiumViewer = this.getCesiumData().viewer;
	const selectedLocation = cesiumViewer.scene.pickPosition(
		rightClick.position
	);
	/* const canvasCoords = cesiumViewer.scene.cartesianToCanvasCoordinates(
		selectedLocation
	); */
	/* this.$refs.floatmenu.style.left = `${canvasCoords.x}px`;
	this.$refs.floatmenu.style.top = `${canvasCoords.y}px`; */
	const pickResult = cesiumViewer.scene.drillPick(rightClick.position);

	const positionCartographic = Ellipsoid.WGS84.cartesianToCartographic(
		selectedLocation
	);
	const latitude = CesiumMath.toDegrees(positionCartographic.latitude);
	const longitude = CesiumMath.toDegrees(positionCartographic.longitude);
	// eslint-disable-next-line prefer-destructuring
	const terrainProvider = cesiumViewer.terrainProvider;
	const positions = [Cartographic.fromDegrees(longitude, latitude)];
	let height;
	const entityWithAssetData = pickResult
		.map((p) => p.primitive.id || (p.id && p.id.layer))
		.map((x) => this.$_linearEntities[x])
		.find((type) => type.type === 'file' || type.data[0].data.asset);
	sampleTerrainMostDetailed(terrainProvider, positions).then(() => {
		height = positions[0].height;
		this.mouseEndPosition = {
			longitude,
			latitude,
			height,
		};
		if (this.dragMode) {
			this.shapeAuthoringWorkflow.lineEntity.show = true;
		}
		
			
	});

	if (!this.dragMode && entityWithAssetData && this.$_linearEntities[entityWithAssetData.id].data[0].data.dimensions) {
		this.shapeAuthoringWorkflow.modelBoundingBox.show = true;	
		console.log(this.shapeAuthoringWorkflow.modelBoundingBox)
		cesiumViewer.scene.requestRender();	
		cesiumViewer.scene.screenSpaceCameraController.enableZoom = false;
		this.dragMode = true;
		this.setFocusedModel(entityWithAssetData.id);		
		
	}

}

export function mouseMoveDefault(mouseMove) {

	const cesiumViewer = this.getCesiumData().viewer;
	const endPosition = cesiumViewer.scene.pickPosition(mouseMove.endPosition, new Cartesian3());
	const pickResult = cesiumViewer.scene.pick(mouseMove.endPosition);
	if (
		pickResult &&
		pickResult.primitive &&
		this.$_linearEntities[pickResult.primitive.id]
	) {
		if (!this.mouseDown) {
			document.getElementById(
				'cesium-viewer'
			).style.cursor = `url('handopen.png'), auto`;
		} else if (this.mouseDown) {
			document.getElementById(
				'cesium-viewer'
			).style.cursor = `url('handclosed.png'), auto`;
		}
	} else {
		document.getElementById('cesium-viewer').style.cursor = 'auto';
	}
	if (this.dragMode) {
		const positionCartographic = Ellipsoid.WGS84.cartesianToCartographic(
			endPosition
		);
		const latitude = CesiumMath.toDegrees(positionCartographic.latitude);
		const longitude = CesiumMath.toDegrees(positionCartographic.longitude);
		// eslint-disable-next-line prefer-destructuring
		const terrainProvider = cesiumViewer.terrainProvider;
		const positions = [Cartographic.fromDegrees(longitude, latitude)];
		let height;
		sampleTerrainMostDetailed(terrainProvider, positions).then(() => {
			height = positions[0].height;
			this.mouseEndPosition = {
				longitude,
				latitude,
				height,
			};
		});
		cesiumViewer.scene.requestRender();
	}

	if (this.modelWorkflow.dragActive && !this.mouseDown) {
		// TODO make drag smooth
		this.moveModel(this.modelWorkflow.focusedId, endPosition);
	}
}

export function mouseMoveSaw(mouseMove) {
	const cesiumViewer = this.getCesiumData().viewer;
	const vid = this.shapeAuthoringWorkflow.draggedVertexId;
	if (vid === -1) return;
	cesiumViewer.scene.pickPosition(
		mouseMove.endPosition,
		this.shapeAuthoringWorkflow.vertices[vid]
	);
	if (
		this.shapeAuthoringWorkflowLoopClosed &&
		(vid === 0 || vid === this.shapeAuthoringWorkflow.vertices.length - 1)
	) {
		mouseMove.endPosition.clone(
			this.shapeAuthoringWorkflow.screenVertices[0]
		);
		mouseMove.endPosition.clone(
			this.shapeAuthoringWorkflow.screenVertices[
			this.shapeAuthoringWorkflow.vertices.length - 1
			]
		);
	} else
		mouseMove.endPosition.clone(
			this.shapeAuthoringWorkflow.screenVertices[vid]
		);
}

export function mouseMoveShift(movement) {
	const cesiumViewer = this.getCesiumData().viewer;
	if (!this.mouseDown) {
		return;
	}
	const selectedLocation = cesiumViewer.scene.pickPosition(
		movement.endPosition, this.cartesian
	);

	this.cartesian = selectedLocation;

	if (this.cartesian) {
		// mouse cartographic
		this.tempCartographic = Ellipsoid.WGS84.cartesianToCartographic(
			selectedLocation, this.tempCartographic
		);

		if (!this.firstPointSet) {
			Cartographic.clone(this.tempCartographic, this.firstPoint);
			this.firstPointSet = true;
		} else {
			this.rectangleSelector.east = Math.max(
				this.tempCartographic.longitude,
				this.firstPoint.longitude
			);
			this.rectangleSelector.west = Math.min(
				this.tempCartographic.longitude,
				this.firstPoint.longitude
			);
			this.rectangleSelector.north = Math.max(
				this.tempCartographic.latitude,
				this.firstPoint.latitude
			);
			this.rectangleSelector.south = Math.min(
				this.tempCartographic.latitude,
				this.firstPoint.latitude
			);
			this.shapeAuthoringWorkflow.selector.show = true;
		}
	}
	cesiumViewer.scene.requestRender();
}

export function leftUp() {
	const cesiumViewer = this.getCesiumData().viewer;
	this.mouseDown = false;
	if (!cesiumViewer.scene.screenSpaceCameraController.enableTilt) {
		cesiumViewer.scene.screenSpaceCameraController.enableTranslate = true;
		cesiumViewer.scene.screenSpaceCameraController.enableTilt = true;
		cesiumViewer.scene.screenSpaceCameraController.enableLook = true;
		cesiumViewer.scene.screenSpaceCameraController.enableCollisionDetection = true;
	}
}

export function leftDownShift() {
	const cesiumViewer = this.getCesiumData().viewer;
	cesiumViewer.scene.screenSpaceCameraController.enableTranslate = false;
	cesiumViewer.scene.screenSpaceCameraController.enableTilt = false;
	cesiumViewer.scene.screenSpaceCameraController.enableLook = false;
	cesiumViewer.scene.screenSpaceCameraController.enableCollisionDetection = false;
	this.mouseDown = true;
	this.shapeAuthoringWorkflow.selector.rectangle.coordinates = new CallbackProperty(
		(time, result) => {
			return Rectangle.clone(this.rectangleSelector);
		},
		false
	);
}

export function leftUpShift() {
	const cesiumViewer = this.getCesiumData().viewer;
	this.mouseDown = false;
	this.firstPointSet = false;
	cesiumViewer.zoomTo(this.shapeAuthoringWorkflow.selector);
	if (!cesiumViewer.scene.screenSpaceCameraController.enableTilt) {
		cesiumViewer.scene.screenSpaceCameraController.enableTranslate = true;		
		cesiumViewer.scene.screenSpaceCameraController.enableTilt = true;
		cesiumViewer.scene.screenSpaceCameraController.enableLook = true;
		cesiumViewer.scene.screenSpaceCameraController.enableCollisionDetection = true;
	}
	/* this.shapeAuthoringWorkflow.selector.rectangle.coordinates = this.rectangleSelector; */
}

export function hidePlacementMarker() {
	const cesiumViewer = this.getCesiumData().viewer;

	this.shapeAuthoringWorkflow.placementMarker.show = false;
	cesiumViewer.scene.requestRender();
}

 
